module.exports = __webpack_public_path__ + "img/init-logo.035fef37.png";